import React, { useMemo } from "react";
import { Container } from "react-bootstrap";
import CmsTopBar from "components/cmslayout/CmsTopBar";
import DataLiteTable from "./components/DataLiteTable";
import SectionHeader from "./components/SectionHeader";
import { rejectionReasonData, vendorRejectionData } from "./mockData";
import type {
  DataLiteColumn,
  RejectionReasonItem,
  VendorRejectionItem,
} from "./types";

const RejectionsPage: React.FC = () => {
  const reasonColumns = useMemo<DataLiteColumn<RejectionReasonItem>[]>(
    () => [
      {
        key: "reason",
        title: "Reason",
        render: (item) => <strong>{item.reason}</strong>,
      },
      {
        key: "count",
        title: "Count",
        className: "data-lite-number-cell",
        render: (item) => item.count,
      },
    ],
    [],
  );

  const vendorColumns = useMemo<DataLiteColumn<VendorRejectionItem>[]>(
    () => [
      {
        key: "vendorName",
        title: "Vendor Name",
        render: (item) => <strong>{item.vendorName}</strong>,
      },
      {
        key: "rejections",
        title: "Rejections",
        className: "data-lite-number-cell",
        render: (item) => item.rejections,
      },
      {
        key: "topReason",
        title: "Top Reason",
        render: (item) => item.topReason,
      },
      {
        key: "action",
        title: "Action",
        render: (item) => (
          <span className={`vendor-action ${item.action.toLowerCase().replaceAll(" ", "-")}`}>
            {item.action}
          </span>
        ),
      },
    ],
    [],
  );

  return (
    <React.Fragment>
      <CmsTopBar title="Rejections" />

      <Container fluid className="dashboard-wrap">
        <Container fluid className="px-3 py-4">
          <div className="data-lite-page data-lite-stack">
            <section className="data-lite-panel">
              <SectionHeader
                title="Order Rejection Analytics"
                description="Rejected orders grouped by reason."
              />
              <DataLiteTable
                columns={reasonColumns}
                data={rejectionReasonData}
                rowKey={(item) => item.id}
                emptyText="No rejected orders found."
              />
            </section>

            <section className="data-lite-panel">
              <SectionHeader
                title="Vendor Rejection Summary"
                description="Operational action suggestions based on rejection patterns."
              />
              <DataLiteTable
                columns={vendorColumns}
                data={vendorRejectionData}
                rowKey={(item) => item.id}
                emptyText="No vendor rejection summary available."
              />
            </section>
          </div>
        </Container>
      </Container>
    </React.Fragment>
  );
};

export default RejectionsPage;
